import React, {Component} from 'react'
import ErrorNotice from "./error-notice";

class ErrorCatcher extends Component {
  state = {
    hasError: false
  };

  componentDidCatch() {
    this.setState({
      hasError: true
    });
  }

  render() {

    if (this.state.hasError) {
      return (
        <ErrorNotice />
      )
    }

    return this.props.children;
  }
}

export default ErrorCatcher;
